var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { AppBarLogo } from './controls/AppBarLogo';
import { AppBarTextLogo } from './controls/AppBarTextLogo';
import { AppBarLink } from './controls/AppBarLink';
import { AppBarSeparator } from './controls/AppBarSeparator';
import { AppBarFill } from './controls/AppBarFill';
import { createUIElement, SIZE_XXL } from "../helpers";
import { STACK_ALIGN, STACK_GAP, StackView } from "../StackView";
import { INDENT } from "../View";
import { APP_BAR_ITEM_TYPE } from './AppBar.public';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    flex-shrink: 0; /* if parent is flexbox-container */\n    display: flex;\n    align-content: center;\n    align-items: center;\n    height: ", ";\n\n    background-color: ", ";\n"], ["\n    position: relative;\n    flex-shrink: 0; /* if parent is flexbox-container */\n    display: flex;\n    align-content: center;\n    align-items: center;\n    height: ", ";\n\n    background-color: ", ";\n"])), SIZE_XXL, function (_a) {
    var theme = _a.theme;
    return theme.colorBackgroundHeader;
});
var BrandSection = styled(StackView)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    overflow: hidden;\n"], ["\n    overflow: hidden;\n"])));
var ServiceSection = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    flex-shrink: 0;\n    flex-grow: 1;\n    display: flex;\n    align-items: stretch;\n    height: 100%;\n"], ["\n    flex-shrink: 0;\n    flex-grow: 1;\n    display: flex;\n    align-items: stretch;\n    height: 100%;\n"])));
var renderItem = function (itemProps) {
    var type = itemProps.type, rest = __rest(itemProps, ["type"]);
    // TODO: refactoring, remove rest
    switch (itemProps.type) {
        case APP_BAR_ITEM_TYPE.custom:
            return itemProps.render();
        case APP_BAR_ITEM_TYPE.fillSpace:
            return React.createElement(AppBarFill, __assign({}, itemProps));
        case APP_BAR_ITEM_TYPE.link:
            return React.createElement(AppBarLink, __assign({}, rest));
        case APP_BAR_ITEM_TYPE.separator:
            return React.createElement(AppBarSeparator, __assign({}, rest));
    }
};
export var AppBar = createUIElement('AppBar', function (_a, ref) {
    var className = _a.className, logo = _a.logo, title = _a.title, items = _a.items, onHomeClick = _a.onHomeClick, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "logo", "title", "items", "onHomeClick", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var hasBrandSection = !!(logo || title);
    return (React.createElement(Wrapper, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'appbar', className: "vm-AppBar " + className, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        hasBrandSection && (React.createElement(BrandSection, { align: STACK_ALIGN.center, gap: STACK_GAP.s, spaceHorizontal: INDENT.s },
            logo && (React.createElement(AppBarLogo, { "data-selector-id": "appbar-logo", onClick: onHomeClick, src: logo })),
            title && (React.createElement(AppBarTextLogo, { "data-selector-id": "appbar-title", onClick: onHomeClick }, title)))),
        items && (React.createElement(ServiceSection, null, items
            .filter(function (item) { return !item.hide; })
            .map(function (item, idx) { return (React.createElement(React.Fragment, { key: item.id || idx }, renderItem(item))); })))));
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=AppBar.js.map